import React from 'react';
import InputMaskControlled from '~/components/input/InputMaskControlled';
import { MaskCPFControlledProps } from '~/types';

const MaskCPFControlled: React.FunctionComponent<MaskCPFControlledProps> = ({ ...rest }) => {
  return <InputMaskControlled {...rest} placeholder="___.___.___-__" format="###.###.###-##" mask="_" isNumericString />;
};

export default MaskCPFControlled;
